import config from "../config";
const root = config.REACT_APP_API_URL;

export const getAllUsers = () => {
  return new Promise((resolve, reject) => {
    const jwt = localStorage.getItem("jwtToken");

    fetch(root + `api/users`, {
      method: "GET",
      headers: {
        Authorization: jwt,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.code === "410") {
          console.log("NOT AUTHORIZED");
        } else if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        console.log({ err });
        reject(err);
      });
  });
}

export const getUserProfile = () => {
  return new Promise((resolve, reject) => {
    const jwt = localStorage.getItem("jwtToken");

    fetch(root + `api/profile`, {
      method: "GET",
      headers: {
        Authorization: jwt,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.code === "410") {
          console.log("NOT AUTHORIZED");
        } else if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        console.log({ err });
        reject(err);
      });
  });
};

export const updateUserProfile = (updateBody) => {
  return new Promise((resolve, reject) => {
    const jwt = localStorage.getItem("jwtToken");

    fetch(root + `api/profile`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: jwt,
      },
      body: JSON.stringify(updateBody),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.code === "410") {
          console.log("NOT AUTHORIZED");
        } else if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        console.log({ err });
        reject(err);
      });
  });
};



export const deleteOneUser = (userId) => {
  return new Promise((resolve, reject) => {
    const jwt = localStorage.getItem("jwtToken");

    fetch(root + `api/users/${userId}`, {
      method: "DELETE",
      headers: {
        Authorization: jwt,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.code === "410") {
          console.log("NOT AUTHORIZED");
        } else if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        console.log({ err });
        reject(err);
      });
  });
}
